import { createTheme } from '@mui/material/styles';

import chervon from 'images/icons/chevron.svg';
import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';

import { remCalc } from '../../utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.masthead': {
		backgroundAttachment: 'fixed',
		position: 'relative',
		'&.masthead--full-height': {
			height: '100vh',
			backgroundSize: 'cover',
		},

		'.masthead__overlay': {
			position: 'absolute',
			width: '100%',
			height: '100%',
			background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.00) 73.73%)',
			backgroundAttachment: 'fixed',
			zIndex: 'var(--mui-zIndex-drawer)',
		},

		'.masthead__video': {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
		},

		'.masthead__content': {
			width: '100%',
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			color: 'white',
			textTransform: 'uppercase',
			textAlign: 'center',

			'.masthead__content__subtitle': {
				marginBottom: remCalc(20),
			},
		},

		'&.masthead--large': {
			'.masthead__overlay': {
				position: 'relative',
				background: 'none',
			},
			'.masthead--image': {
				backgroundSize: 'cover',
				height: remCalc('241'),
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				[theme.breakpoints.up('lg')]: {
					height: remCalc('556'),
				},
				[theme.breakpoints.up('xl')]: {
					height: remCalc('700'),
				}
			},
			'.masthead__video': {
				maxHeight: `${remCalc('241')} !important`,
				[theme.breakpoints.up('lg')]: {
					maxHeight: `${remCalc('556')} !important`,
				},
				[theme.breakpoints.up('xl')]: {
					maxHeight: `${remCalc('700')} !important`,
				},
			},
			'.masthead__content': {
				position: 'relative',
				top: 'unset',
				transform: 'unset',
				'padding': '40px 0px',
				'&.masthead__content--no-body': {
					'padding': '40px 0px 40px',
				},
				[theme.breakpoints.up('lg')]: {
					'padding': '80px 0px',
				},
				'.masthead__content__title': {
					color: getColor('ivory', 700),
					fontSize: remCalc('32px'),
					lineHeight: remCalc(40),
					letterSpacing: '-0.02rem',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('54px'),
						lineHeight: remCalc(54),
						letterSpacing: remCalc(0.5),
					}
				},
				'.masthead__content__subtitle': {
					color: getColor('ivory', 700),
					fontSize: remCalc('14px'),
					lineHeight: remCalc(18),
					letterSpacing: remCalc(0.28),
					'a': {
						color: getColor('ivory', 700),
						fontSize: remCalc('14px'),
						lineHeight: remCalc(18),
						letterSpacing: remCalc(0.28),
						textDecoration: 'none',
						fontWeight: 400,
					}
				},
				'.masthead__content__body': {
					color: getColor('ivory', 600),
					textTransform: 'none',
					fontFamily: "Avenir Next",
					fontSize: remCalc('23px'),
					fontStyle: 'italic',
					fontWeight: 500,
					lineHeight: remCalc(28),
					letterSpacing: remCalc(0.5),
					width: '80%',
					margin: '20px auto 0',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('24px'),
						lineHeight: remCalc(32),
						width: '50%',
					}
				}
			}
		},

		'&.masthead--small': {
			'.masthead__overlay': {
				position: 'relative',
				background: 'none',
			},
			'.masthead--image': {
				backgroundSize: 'cover',
				height: remCalc('241'),
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				[theme.breakpoints.up('lg')]: {
					height: remCalc('356'),
				},
				[theme.breakpoints.up('xl')]: {
					height: remCalc('500'),
				}
			},
			'.masthead__video': {
				maxHeight: `${remCalc('241')} !important`,
				[theme.breakpoints.up('lg')]: {
					maxHeight: `${remCalc('356')} !important`,
				},
				[theme.breakpoints.up('xl')]: {
					maxHeight: `${remCalc('500')} !important`,
				},
			},
			'.masthead__content': {
				position: 'relative',
				top: 'unset',
				transform: 'unset',
				'padding': '40px 0px',
				'&.masthead__content--no-body': {
					'padding': '40px 0px 0px',
				},
				[theme.breakpoints.up('lg')]: {
					'padding': '80px 0px',
				},
				'.masthead__content__title': {
					color: getColor('ivory', 700),
					fontSize: remCalc('32px'),
					lineHeight: remCalc(40),
					letterSpacing: '-0.02rem',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('54px'),
						lineHeight: remCalc(54),
						letterSpacing: remCalc(0.5),
					}
				},
				'.masthead__content__subtitle': {
					color: getColor('ivory', 700),
					fontSize: remCalc('14px'),
					lineHeight: remCalc(18),
					letterSpacing: remCalc(0.28),
					'a': {
						color: getColor('ivory', 700),
						fontSize: remCalc('14px'),
						lineHeight: remCalc(18),
						letterSpacing: remCalc(0.28),
						textDecoration: 'none',
						fontWeight: 400,
					}
				},
				'.masthead__content__body': {
					color: getColor('ivory', 600),
					textTransform: 'none',
					fontFamily: "Avenir Next",
					fontSize: remCalc('23px'),
					fontStyle: 'italic',
					fontWeight: 500,
					lineHeight: remCalc(28),
					letterSpacing: remCalc(0.5),
					width: '80%',
					margin: '20px auto 0',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('24px'),
						lineHeight: remCalc(32),
						width: '50%',
					}
				}
			}
		},

		'&.masthead--no-image': {
			'padding': '285px 0px 90px',
			'.masthead__overlay': {
				position: 'relative',
				background: 'none',
			},
			'.masthead__content': {
				position: 'relative',
				top: 'unset',
				transform: 'unset',
				'.masthead__content__title': {
					color: getColor('ivory', 700),
				},
				'.masthead__content__subtitle': {
					color: getColor('ivory', 700),
					'a': {
						color: getColor('ivory', 700),
						fontSize: remCalc('14px'),
						lineHeight: remCalc(18),
						letterSpacing: remCalc(0.28),
						textDecoration: 'none',
						fontWeight: 400,
					}
				},
				'.masthead__content__body': {
					color: getColor('ivory', 600),
					textTransform: 'none',
					fontFamily: "Avenir Next",
					fontSize: remCalc('24px'),
					fontStyle: 'italic',
					fontWeight: 500,
					lineHeight: remCalc(32),
					letterSpacing: remCalc(0.5),
					width: '50%',
					margin: '20px auto 0',
				}
			}
		},

		'&.masthead--withVideo:not(.masthead--full-height)': {
			display: 'flex',
			gap: `0 ${remCalc('50px')}`,
			padding: '90px 0',
			flexDirection: 'column-reverse',
			'.masthead__video': {
				maxHeight: remCalc(241),
			},
			'&.masthead--small, &.masthead--medium, &.masthead--large': {
				flexDirection: 'column',
				padding: '0 0 40px 0',
				'.masthead__overlay': {
					position: 'absolute',
					zIndex: -1,
				}
			},
			'.masthead__gallery_row': {
				paddingTop: 0,
			}
		},

		// '&.masthead--small': {
		// 	'padding': '285px 0px 90px',
		// 	'.masthead__overlay': {
		// 		position: 'relative',
		// 		background: 'none',
		// 	},
		// 	'.masthead__content': {
		// 		position: 'relative',
		// 		top: 'unset',
		// 		transform: 'unset',
		// 		'.masthead__content__title': {
		// 			color: getColor('ivory', 700),
		// 		},
		// 		'.masthead__content__subtitle': {
		// 			color: getColor('ivory', 700),
		// 		},
		// 		'.masthead__content__body': {
		// 			color: getColor('ivory', 600),
		// 			textTransform: 'none',
		// 			fontFamily: "Avenir Next",
		// 			fontSize: remCalc('24px'),
		// 			fontStyle: 'italic',
		// 			fontWeight: 500,
		// 			lineHeight: remCalc(32),
		// 			letterSpacing: remCalc(0.5),
		// 			width: '50%',
		// 			margin: '20px auto 0',
		// 		}
		// 	}
		// },

		'&.masthead--medium': {
			'padding': '0',
			'.masthead__overlay': {
				position: 'relative',
				background: 'none',
			},
			'.masthead--image': {
				backgroundSize: 'cover',
				height: remCalc('413'),
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				[theme.breakpoints.up('lg')]: {
					height: 'calc(100vh - 300px)',
				}
			},
			'.masthead__video': {
				maxHeight: `${remCalc('413')} !important`,
				[theme.breakpoints.up('lg')]: {
					maxHeight: `calc(100vh - 300px) !important`,
				}
			},
			'.masthead__gallery_row': {
				position: 'relative',
				// transform: 'translateY(-74px)',
				zIndex: 'calc(var(--mui-zIndex-drawer) + 1)',
				paddingTop: remCalc('50px'),
				'.masthead__gallery_content': {
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-end',
					order: '2',
					[theme.breakpoints.up('sm')]: {
						order: 'unset',
					},
					'.masthead__gallery_content__title': {
						fontSize: remCalc('32px'),
						lineHeight: remCalc(40),
						letterSpacing: '-0.02rem',
						[theme.breakpoints.up('lg')]: {
							fontSize: remCalc('54px'),
							lineHeight: remCalc(67),
							letterSpacing: remCalc(0.5),
						}
					},
					'.masthead__gallery_content__subtitle': {
						color: getColor('ivory', 700),
						fontSize: remCalc('14px'),
						lineHeight: remCalc(18),
						letterSpacing: remCalc(0.28),
						textTransform: 'uppercase',
						marginBottom: remCalc('28px'),
						'a': {
							color: getColor('ivory', 700),
							fontSize: remCalc('14px'),
							lineHeight: remCalc(18),
							letterSpacing: remCalc(0.28),
							textDecoration: 'none',
							fontWeight: 400,
						}
					},
				},
			}
		},

		'&.masthead--withGallery': {
			'padding': '0',
			'.masthead--image': {
				backgroundSize: 'cover',
				height: remCalc('413'),
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				[theme.breakpoints.up('lg')]: {
					height: 'calc(100vh - 300px)',
				}
			},
			'.masthead__gallery_row': {
				position: 'relative',
				transform: 'translateY(-74px)',
				marginBottom: remCalc('-74px'),
				zIndex: 'calc(var(--mui-zIndex-drawer) + 1)',
				paddingTop: '0px',
				'&.masthead__gallery_row--long-title': {
					transform: 'initial',
					marginBottom: 0,
					[theme.breakpoints.down('ms')]: {
						marginTop: remCalc('-40px'),
					},
					'.masthead__gallery_content__title:only-child': {
						marginTop: remCalc('40px'),
						[theme.breakpoints.only('xs')]: {
							marginTop: remCalc('0'),
						},
					},
					'.masthead__gallery_content': {
						justifyContent: 'flex-start',
					},
					'.masthead__gallery_content__subtitle': {
						marginTop: remCalc('40px'),
						[theme.breakpoints.only('xs')]: {
							marginTop: remCalc('0'),
						},
					},
					'.masthead__gallery_container': {
						transform: 'translateY(-74px)',
					}
				},
				'.masthead__gallery_content': {
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-end',
					order: '2',
					[theme.breakpoints.up('sm')]: {
						order: 'unset',
					},
					'.masthead__gallery_content__title': {
						fontSize: remCalc('32px'),
						lineHeight: remCalc(40),
						letterSpacing: '-0.02rem',
						[theme.breakpoints.up('lg')]: {
							fontSize: remCalc('54px'),
							lineHeight: remCalc(67),
							letterSpacing: remCalc(0.5),
						}
					},
					'.masthead__gallery_content__subtitle': {
						color: getColor('ivory', 700),
						fontSize: remCalc('14px'),
						lineHeight: remCalc(18),
						letterSpacing: remCalc(0.28),
						'a': {
							fontWeight: 400,
						},
					},
				},
				'.masthead__gallery_container': {
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'flex-end',
					[theme.breakpoints.between('sm', 'lg')]: {
						gridColumn: '8/14',
					},
					'.masthead__gallery': {
						margin: 0,
						border: `solid 10px ${getColor('white')}`,
						background: getColor('white'),
						width: '100%',
						[theme.breakpoints.up('sm')]: {
							width: remCalc('553'),
						},
						'.masthead__gallery_slide': {
							'.masthead__gallery_slide_background': {
								aspectRatio: '1.78/1',
								backgroundRepeat: 'no-repeat',
								backgroundSize: 'cover',
								backgroundPosition: 'center',
							}
						},
						'.masthead__gallery_navigation': {
							position: 'absolute',
							right: remCalc('25px'),
							bottom: remCalc('25px'),
							zIndex: 2,
							display: 'flex',
							flexDirection: 'row',
							gap: remCalc('10px'),
							[theme.breakpoints.down('ms')]: {
								display: 'none',
							},
							'button': {
								display: 'flex',
								width: remCalc('52px'),
								height: remCalc('52px'),
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center',
								gap: remCalc('10px'),
								aspectRatio: 1/1,
								border: 'none',
								borderRadius: remCalc('6px'),
								...theme.mixins.glass,
								transition: 'all .2s',
								'svg': {
									color: getColor('white'),
									width: remCalc('23px'),
								},
								[theme.breakpoints.up('lg')]: {
									'&:hover': {
										cursor: 'pointer',
										background: 'rgba(255, 255, 255, 0.35)',
										boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
										backdropFilter: 'blur(15px)',
									}
								}
							}
						},
						'.masthead__gallery_bullets': {
							position: 'absolute',
							bottom: remCalc('17px'),
							display: 'flex',
							flexDirection: 'row',
							transition: '300ms opacity',
							transform: 'translate3d(0, 0, 0)',
							zIndex: '10',
							width: '100%',
							paddingLeft: remCalc('17px'),
							paddingRight: remCalc('17px'),
							[theme.breakpoints.up('ms')]: {
								display: 'none',
							},
							'.masthead__gallery_bullet': {
								flex: 'auto',
								height: remCalc('4px'),
								background: 'rgba(255, 255, 255, 0.40)',
								transition: 'all .2s',
								border: 'none',
								[theme.breakpoints.up('lg')]: {
									'&:hover': {
										cursor: 'pointer',
									}
								},
								'&.masthead__gallery_bullet-active': {
									background: 'white',
								}
							}
						}
					}
				}
			}
		},

		'.masthead__content__subtitle__link': {
			position: 'relative',
			zIndex: '2',
			display: 'inline-flex',
			gap: remCalc('10px'),
			alignItems: 'center',
			textDecoration: 'none',
			textTransform: 'uppercase',
			color: getColor('ivory', 700),
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc('14px'),
			fontStyle: 'normal',
			fontWeight: 400,
			lineHeight: 1.25,
			letterSpacing: remCalc('0.28px'),
			'&:hover': {
				textDecoration: 'underline',
			},
			'&::before': {
				display: 'inline-block',
				content: '""',
				width: remCalc('6px'),
				height: remCalc('12px'),
				backgroundColor: 'currentColor',
				WebkitMask: `url(${chervon}) no-repeat center / contain`,
				mask: `url(${chervon}) no-repeat center / contain`,
				transform: 'scaleX(-1)',
				transformOrigin: 'center',
			}
		}
	}
}

export default styles;